<template>
    <div>
        <v-layout class="pa-0 mt-2" row>
            <div
                style=""
                class="mx-3 pt-3 text-xs-center font-weight-medium title"
            >
                Publications ({{ publications.length }})
            </div>

            <v-btn small color="success" @click="openNewPublicationDialog()"
                >New Publication</v-btn
            >
        </v-layout>
        <v-layout row wrap>
            <v-card
                v-for="(publication, index) in publications"
                class="pa-3 mb-3 mx-2"
                style="width: 32%;"
            >
                <v-layout row class="pa-0" align-start justify-start>
                    <div v-if="!publication.editing">
                        <div class="title">
                            {{
                                "(" +
                                    publication.sort +
                                    ") " +
                                    publication.fileName
                            }}
                        </div>
                        <div class="body-1">{{ publication.description }}</div>
                        <div class="body-1" v-if="publication.expires">
                            <span class="mr-1 mt-2 font-weight-medium"
                                >Expires:</span
                            >
                            {{ publication.expires | date }}
                        </div>
                        <div
                            class="body-1"
                            v-if="publication.showAtParentInfoSection"
                        >
                            <span class="mr-1 mt-2 font-weight-medium"
                                >Show At Parent Info Section:</span
                            >
                            {{
                                publication.showAtParentInfoSection
                                    ? "Yes"
                                    : "No"
                            }}
                        </div>
                        <div
                            class="body-1"
                            v-if="publication.showAtUserManualsSection"
                        >
                            <span class="mr-1 mt-2 font-weight-medium"
                                >Show At User Manual Section:</span
                            >
                            {{
                                publication.showAtUserManualsSection
                                    ? "Yes"
                                    : "No"
                            }}
                        </div>
                    </div>
                    <div v-if="publication.editing" style="width: 50%;">
                        <v-text-field
                            label="Name"
                            v-model="publication.fileName"
                            :rules="[rules.required]"
                            ref="fileName"
                        >
                        </v-text-field>
                        <v-text-field
                            label="Description"
                            v-model="publication.description"
                            :rules="[rules.required]"
                            ref="description"
                        >
                        </v-text-field>
                        <v-text-field
                            label="Sort"
                            v-model="publication.sort"
                            type="number"
                            ref="sort"
                        >
                        </v-text-field>
                        <v-menu
                            v-model="publication.datePickerMenu"
                            :close-on-content-click="true"
                            offset-y
                            full-width
                            prepend-icon="mdi-calendar"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="publication.expires"
                                    :value="publication.expires"
                                    label="Expire Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-on="on"
                                    clearable
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="publication.expires"
                            ></v-date-picker>
                        </v-menu>

                        <v-checkbox
                            v-model="publication.showAtParentInfoSection"
                            label="Show At Parent Info Section"
                            color="success"
                            class="mt-0 mb-3"
                            hide-details
                        ></v-checkbox>

                        <v-checkbox
                            v-model="publication.showAtUserManualsSection"
                            label="Show At User Manuals Section"
                            color="success"
                            class="mt-0 mb-3"
                            hide-details
                        ></v-checkbox>

                        <v-btn
                            :disabeld="loading"
                            small
                            color="success"
                            :loading="uploading"
                            @click="pickReplacmentFile(publication)"
                            ><v-icon dark left>mdi-cloud-upload</v-icon
                            >Upload</v-btn
                        >
                        <input
                            type="file"
                            style="display: none"
                            ref="replacmentFiles"
                            accept=".pdf, image/*"
                            @change="
                                onReplacmentFilePicked($event, publication)
                            "
                        />
                    </div>

                    <v-spacer></v-spacer>
                    <v-btn
                        small
                        outline
                        color="success"
                        class="mr-1"
                        style="height: 28px;"
                        @click="download(publication)"
                        v-if="!publication.editing"
                        >Download</v-btn
                    >
                    <v-btn
                        style="height: 28px;"
                        small
                        color="success"
                        class="mr-1"
                        v-if="!publication.editing"
                        @click="edit(publication)"
                        >Edit</v-btn
                    >
                    <v-btn
                        small
                        color="success"
                        style="height: 28px;"
                        v-if="!publication.editing"
                        @click="openDeletePublicationDialog(publication)"
                        >Delete</v-btn
                    >
                    <v-btn
                        style="height: 28px;"
                        small
                        color="success"
                        outline
                        v-if="publication.editing"
                        @click="rollback(publication)"
                        >Cancel</v-btn
                    >
                    <v-btn
                        style="height: 28px;"
                        small
                        color="success"
                        :loading="publication.uploading"
                        v-if="publication.editing"
                        @click="save(publication)"
                        >Save</v-btn
                    >
                </v-layout>
                <div style="height: 500px; overflow-y: auto;" class="mt-3">
                    <pdf
                        v-if="isPdf(publication.fileURL)"
                        style="max-height: 500px !important; width: 100%;"
                        :src="publication.fileURL"
                    ></pdf>
                    <img
                        style="max-height: 500px !important; width: 100%;"
                        v-if="!isPdf(publication.fileURL)"
                        :src="publication.fileURL"
                    />
                </div>
            </v-card>
        </v-layout>
        <v-dialog persistent v-model="newPublicationDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pa-0 pb-2"
                    >New Publication</v-card-title
                >
                <v-btn
                    :disabeld="loading"
                    small
                    color="success"
                    :loading="uploading"
                    @click="pickFile()"
                    ><v-icon dark left>mdi-cloud-upload</v-icon>Upload</v-btn
                >
                <input
                    type="file"
                    style="display: none"
                    ref="files"
                    accept=".pdf, image/*"
                    @change="onFilePicked($event)"
                />

                <div
                    style="height: 500px; overflow-y: auto;"
                    class="mt-3"
                    v-if="newPublication.fileURL"
                >
                    <pdf
                        style="max-height: 500px !important; width: 100%;"
                        :src="newPublication.fileURL"
                        v-if="isPdf(newPublication.fileURL)"
                    ></pdf>
                    <img
                        style="max-height: 500px !important; width: 100%;"
                        v-if="!isPdf(newPublication.fileURL)"
                        :src="newPublication.fileURL"
                    />
                </div>
                <v-text-field
                    label="Name"
                    v-model="newPublication.fileName"
                    :rules="[rules.required]"
                    ref="newPublicationFileName"
                >
                </v-text-field>
                <v-text-field
                    label="Description"
                    v-model="newPublication.description"
                    :rules="[rules.required]"
                    ref="newPublicationDescription"
                >
                </v-text-field>
                <v-text-field
                    type="number"
                    label="Sort"
                    v-model="newPublication.sort"
                >
                </v-text-field>
                <v-menu
                    v-model="newPublication.datePickerMenu"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-calendar"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="newPublication.expires"
                            :value="newPublication.expires"
                            label="Expire Date"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="newPublication.expires"
                    ></v-date-picker>
                </v-menu>
                <v-checkbox
                    v-model="newPublication.showAtParentInfoSection"
                    label="Show At Parent Info Section"
                    color="success"
                    class="mt-0 mb-3"
                    hide-details
                ></v-checkbox>
                <v-checkbox
                    v-model="newPublication.showAtUserManualsSection"
                    label="Show At User Manuals Section"
                    color="success"
                    class="mt-0 mb-3"
                    hide-details
                ></v-checkbox>

                <v-card-actions class="mr-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="closeNewPublicationDialog"
                        >Close</v-btn
                    >
                    <v-btn
                        :loading="newPublication.updating"
                        color="success"
                        @click="save(newPublication)"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="deletePublicationDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="text-warning headline"
                    >Are You Sure?</v-card-title
                >
                <v-card-text class="mb-3 py-0">
                    You will now delete {{ publicationToDelete.fileName }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deletePublicationDialog = false"
                        >Close</v-btn
                    >
                    <v-btn
                        :loading="deleting"
                        color="success"
                        @click="deletePublication()"
                        >Delete</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import moment from "moment";
import pdf from "vue-pdf";
import { toISOLocal } from "../utils/helpers.js";

export default {
    components: {
        pdf,
    },
    data() {
        return {
            publications: [],
            files: [],

            newPublicationDialog: false,
            newPublication: {
                fileName: "",
                description: "",
                sort: "",
                datePickerMenu: false,
                updating: false,
                expires: "",
                fileURL: "",
                showAtParentInfoSection: false,
                showAtUserManualsSection: false,
            },

            deletePublicationDialog: false,
            deleting: false,
            uploading: false,
            publicationToDelete: "",

            page: 1,
            numPages: 0,

            rules: {
                required: (value) => !!value || "Required.",
            },
        };
    },
    async created() {
        this.loadPublications();
    },
    watch: {},
    mounted() {},
    beforeDestroy() {},
    computed: {},
    methods: {
        async loadPublications() {
            this.loading = true;

            const publications = await this.$http.get("api/publications/get");

            this.publications = publications.map((publication) => {
                publication.updating = false;
                publication.editing = false;
                publication.datePickerMenu = false;
                publication.sort = publication.sort ? publication.sort : "0";

                if (publication.expires) {
                    publication.expires = toISOLocal(
                        new Date(publication.expires),
                    ).substr(0, 10);
                }

                return publication;
            });

            this.loading = false;
        },
        download(publication) {
            window.open(publication.fileURL);
        },
        edit(publication) {
            publication.editing = true;
            publication.originalExpires = publication.expires;
            publication.originalFileName = publication.fileName;
            publication.originalFileUrl = publication.fileURL;
            publication.originalDescription = publication.description;
            publication.originalSort = publication.sort;
            publication.showAtParentInfoSection =
                publication.showAtParentInfoSection;
            publication.showAtUserManualsSection =
                publication.showAtUserManualsSection;
        },
        rollback(publication) {
            publication.expires = publication.originalExpires;
            publication.fileName = publication.originalFileName;
            publication.fileURL = publication.originalFileUrl;
            publication.description = publication.originalDescription;
            publication.sort = publication.originalSort;
            publication.showAtParentInfoSection =
                publication.showAtParentInfoSection;
            publication.showAtUserManualsSection =
                publication.showAtUserManualsSection;

            publication.editing = false;
        },
        async save(publication) {
            const isNew = !publication.id;

            if (isNew) {
                if (!publication.fileURL) {
                    this.$notify({
                        group: "notification",
                        text: "Please upload file",
                        type: "error",
                    });

                    return;
                }

                if (
                    !this.$refs.newPublicationFileName.validate(true) ||
                    !this.$refs.newPublicationDescription.validate(true)
                )
                    return;
            }

            try {
                publication.updating = true;

                await this.$http.post("api/publications/save", publication);

                publication.editing = false;
                publication.updating = false;

                this.closeNewPublicationDialog();

                this.loadPublications();
            } catch (e) {
                publication.editing = false;
            }
        },
        openNewPublicationDialog() {
            this.newPublicationDialog = true;
        },
        closeNewPublicationDialog() {
            this.newPublicationDialog = false;

            this.newPublication.showAtParentInfoSection = false;
            this.newPublication.showAtUserManualsSection = false;
            this.newPublication.fileURL = "";
            this.newPublication.fileName = "";
            this.newPublication.description = "";
            this.newPublication.sort = "";
        },
        openDeletePublicationDialog(publication) {
            this.publicationToDelete = publication;

            this.deletePublicationDialog = true;
        },
        isPdf(url) {
            return url.toLowerCase().includes("pdf");
        },
        pickFile() {
            this.$refs.files.click();
        },
        async onFilePicked(e) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            try {
                var formData = new FormData();

                this.files = files;

                formData.append("upload_file", this.files[0]);

                const response = await this.$http.post(
                    "api/adminPortal/UploadFile?",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.newPublication.fileURL = response.url;

                this.uploading = false;

                this.loadPublications();
            } catch (e) {
                this.uploading = false;
            }
        },
        pickReplacmentFile(publication) {
            const publicationsEditing = this.publications.filter(
                (p) => p.editing,
            );
            const index = publicationsEditing.indexOf(publication);

            this.$refs.replacmentFiles[index].click();
        },
        async onReplacmentFilePicked(e, publication) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            try {
                var formData = new FormData();

                this.files = files;

                formData.append("upload_file", this.files[0]);

                const response = await this.$http.post(
                    "api/adminPortal/UploadFile?",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                publication.fileURL = response.url;

                this.uploading = false;

                //this.loadPublications();
            } catch (e) {
                this.uploading = false;
            }
        },
        async deletePublication() {
            this.deleting = true;

            await this.$http.post(
                "api/publications/delete?id=" + this.publicationToDelete.id,
            );

            this.deleting = false;
            this.deletePublicationDialog = false;

            this.loadPublications();
        },
    },
};
</script>
<style></style>
